import Statistics from "./Statistics";

export default class StatisticsIncrementor {
    /**
     * @param {Statistics} globalStatitics 
     * @param {Statistics} runStatistics 
     */
    constructor(globalStatitics, runStatistics) {
        /**
         * @constant
         * @type {Statistics}
         */
        this.globalStatitics = globalStatitics;
        /**
         * @constant
         * @type {Statistics}
         */
        this.runStatistics = runStatistics;
    }

    /**
     * @param {number} turns 
     */
    incrementTurns(turns) {
        this.globalStatitics.incrementTurns(turns);
        this.runStatistics.incrementTurns(turns);
    }

    /**
     * @param {number} depth 
     */
    tileDepth(depth) {
        this.globalStatitics.tileDepth(depth);
        this.runStatistics.tileDepth(depth);
    }

    /**
     * @param {GridTile} tile 
     */
    onTileMined(tile) {
        this.globalStatitics.onTileMined(tile);
        this.runStatistics.onTileMined(tile);
    }

    /**
     * @param {BigNum} ore 
     */
    incrementOre(ore) {
        this.globalStatitics.incrementOre(ore);
        this.runStatistics.incrementOre(ore);
    }

    /**
     * @param {BigNum} ore 
     */
    incrementUpgradeOre(ore) {
        this.globalStatitics.incrementUpgradeOre(ore);
        this.runStatistics.incrementUpgradeOre(ore);
    }

    /**
     * @param {BigNum} gold 
     */
    incrementGold(gold) {
        this.globalStatitics.incrementGold(gold);
        this.runStatistics.incrementGold(gold);
    }
    /**
     * @param {BigNum} ruby 
     */
    incrementRuby(ruby) {
        this.globalStatitics.incrementRuby(ruby);
        this.runStatistics.incrementRuby(ruby);
    }
    /**
     * @param {BigNum} prestigePoints 
     */
    incrementPrestigePoints(prestigePoints) {
        this.globalStatitics.incrementPrestigePoints(prestigePoints);
        this.runStatistics.incrementPrestigePoints(prestigePoints);
    }

    incrementMinedByLaser() {
        this.globalStatitics.incrementMinedByLaser();
        this.runStatistics.incrementMinedByLaser();
    }
    incrementMinedByDrill() {
        this.globalStatitics.incrementMinedByDrill();
        this.runStatistics.incrementMinedByDrill();
    }
    incrementMinedByOrbit() {
        this.globalStatitics.incrementMinedByOrbit();
        this.runStatistics.incrementMinedByOrbit();
    }
    incrementMinedByFissure() {
        this.globalStatitics.incrementMinedByFissure();
        this.runStatistics.incrementMinedByFissure();
    }
    incrementMinedByLightning() {
        this.globalStatitics.incrementMinedByLightning();
        this.runStatistics.incrementMinedByLightning();
    }
    incrementMinedByMissile() {
        this.globalStatitics.incrementMinedByMissile();
        this.runStatistics.incrementMinedByMissile();
    }

}